import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import { registerAllModules } from 'handsontable/registry';
import { HotTable } from "@handsontable/react";
import "handsontable/dist/handsontable.full.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { SiGooglesheets } from "react-icons/si";
import { Link, useLocation, useNavigate, useParams, UNSAFE_NavigationContext } from "react-router-dom";
import { dacr, personalSheetsCrud } from "../../../../api/sheetApi";
import ReactNotifications, { showApiErrors } from "../../../common/reactNotifications/ReactNotifications";
import { getErrorStatus, sucessState200 } from "../../../../utils/constants/utilsConstants";
import { downloadToCsv, financeCrud } from "../../../../api/financeApi";
import { FaFileExport } from "react-icons/fa";
import { HyperFormula } from "hyperformula";
import * as utilConstants from "../../../../utils/constants/utilsConstants";
import { yearCrud } from "../../../../api/yearApi";
import { companyCrud } from "../../../../api/company";
import { categoryCrud } from "../../../../api/category";
import { unitCrud } from "../../../../api/UnitsApi";
import VersionHistory from "./VersionHistory";
import Context from "../../../../context/Context";
import ShareSheetAccessModal from "./ShareSheetAccessModal";
import SheetLockFeature from "./SheetLockFeature";
import AiUploadFeature from "./AiUploadFeature";
import CustomExportButton from "./CustomExportButton";
import HideRowsAndCols from "./HideRowsAndCols";
import CompanyModal from "../../../company/CompanyModal";
import CategoryModal from "../../../category/CategoryModal";
import UnitModal from "../../../units/UnitModal";
import YearModal from "../../../year/YearModal";
registerAllModules();

const Sheet = forwardRef(({ onSave }, ref) => {

  const hotTableRef = useRef(null);
  const { tab } = useParams();
  const [activeTab, setActiveTab] = useState(tab);
  // const [sharedSheets, setSharedSheets] = useState([]);
  // const [personalSheets, setPersonalSheets] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSheetLock, setIsSheetLock] = useState(false);

  const { defaultColumns, defaultRow, currentSheet, setCurrentSheet,
    validSheetData, setValidSheetData, allComments, setAllComments,
    currentSheetIndex, setCurrentSheetIndex, selectedSheetInfo, setSelectedSheetInfo, setSheetRestoredDate, user } = useContext(Context);


  const [sheetCreatedById, setSheetCreatedById] = useState(null);
  const [currentSheetType, setCurrentSheetType] = useState("");
  const [categoryNames, setCategoryNames] = useState([]);
  const [categoryCodes, setCategoryCodes] = useState([]);
  const [companyIdentifiers, setCompanyIdentifiers] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [categories, setCategories] = useState([]);
  const [allYears, setAllYears] = useState([]);
  const [years, setYears] = useState([]);
  const [allUnits, setAllUnits] = useState([]);
  const [units, setUnits] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [loadedRows, setLoadedRows] = useState(50);
  const [loadedCols, setLoadedCols] = useState(26);
  const [isBtnDisable, setIsBtnDisable] = useState(true);
  const [isTitleChanged, setIsTitleChanged] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [maskedRange, setMaskedRange] = useState(null);
  const [isCompanyModalOpen, setIsCompanyModalOpen] = useState(false);
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [isUnitModalOpen, setIsUnitModalOpen] = useState(false);
  const [isYearModalOpen, setIsYearModalOpen] = useState(false);

  const [hasFetched, setHasFetched] = useState(false);
  const [loadingSheetId, setLoadingSheetId] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const location = useLocation();
  const userId = localStorage.getItem('userId');
  const handleCreateSheet = (type) => {
    setCurrentSheetType(type);
    setIsModalOpen(true);
    setCurrentSheet({ name: "", data: [defaultColumns, []] });
    setCurrentSheetIndex(null);
    setIsBtnDisable(true);
    setIsSheetLock(false);
    setIsSheetLock(false);
    setAllComments([]);
  };

  useEffect(() => {
    setActiveTab(tab);
    setIsModalOpen(false);
  }, [tab])

  const handleCloseModal = () => {
    if (hasUnsavedChanges) {
      const confirmed = window.confirm(
        "You have unsaved changes. Do you want to save before closing?"
      );

      if (confirmed) {
        saveSheet();
        setTimeout(() => {
          // setIsModalOpen(false);
          setHasUnsavedChanges(false);
          setIsBtnDisable(true);
        }, 500);
      } else {
        onSave();
        setCurrentSheetIndex(null);
        setIsModalOpen(false);
        setHasUnsavedChanges(false);
        setIsBtnDisable(true);
      }
    } else {
      onSave();
      setIsModalOpen(false);
      setIsSheetLock(false);
      setCurrentSheetIndex(null);
      setValidSheetData([]);
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  const { navigator } = useContext(UNSAFE_NavigationContext);

  useEffect(() => {
    if (!hasUnsavedChanges) return;
    const push = navigator.push;
    navigator.push = (...args) => {
      const confirmed = window.confirm(
        "You have unsaved changes. Do you want to save before leaving?"
      );

      if (confirmed) {
        saveSheet();
        // setTimeout(() => push(...args), 500);
      } else {
        push(...args);
      }
    };

    return () => {
      navigator.push = push;
    };
  }, [hasUnsavedChanges, navigator]);

  const saveSheet = () => {
    if (!currentSheet?.name?.trim()) {
      ReactNotifications("Sheet name should not be empty!!", getErrorStatus);
      return;
    }
    setIsSaving(true);
    const hotInstance = hotTableRef.current.hotInstance;
    let data = hotInstance.getData();
    const cells = handleComment();

    data = data?.map((row) => {
      if (
        row?.some(
          (cell) => typeof cell === "string" && (cell.startsWith("+") || cell.startsWith("="))
        )
      ) {
        return row?.map(() => "");
      }
      return row;
    });

    hotInstance.loadData(data);

    const rows = data
      ?.slice(1)
      ?.map((row, idx) => ({ row, idx }))
      ?.filter(({ row }) => row.some((cell) => cell !== null && cell !== ""))
      ?.map(({ row, idx }) => {
        const actualRowIndex = idx + 1;
        const company = companies?.find((comp) => comp.name === row[0]);
        const categoryName = categories?.find((cat) => cat.name === row[1]);
        const categoryCode = categories?.find((cat) => cat.code === row[2]);
        const unit = allUnits?.find((unit) => unit.unit === row[3]);

        const yearlyData = [];
        for (let col = 4; col < row.length; col++) {
          const year = data[0][col];
          const cellValue = row[col];
          const yearId = allYears?.find((yar) => yar.year === year);
          if (year) yearlyData.push({ year: yearId?.id, value: cellValue });
        }

        return {
          row_id: actualRowIndex,
          sheet_company: company ? company.id : null,
          category:
            categoryCode ? categoryCode.id : categoryName ? categoryName.id : null,
          unit: unit ? unit?.id : null,
          time_frame_data: yearlyData,
        };
      });

    const isShared = currentSheetType === "shared";
    const method = currentSheetIndex === null ? "post" : "put";

    const payload = {
      title: currentSheet?.name,
      ...(isShared && { is_shared: true }),
      ...(method === "put" && { id: currentSheetIndex }),
    };

    if (isTitleChanged) {
      personalSheetsCrud(payload, method, (response) => {
        if (response?.status === true) {
          setCurrentSheetIndex(response?.data?.id);
          setLoadingSheetId(response?.data?.id);
          setCurrentSheet({ ...currentSheet, name: response?.data?.title });
          setIsTitleChanged(false);
          saveFinanceData(response?.data?.id);
        } else {
          currentSheet?.name === ""
            ? ReactNotifications("Sheet name should not be empty!!", getErrorStatus)
            : ReactNotifications(response?.data?.message, getErrorStatus);
          setIsSaving(false);
        }
      });
    } else {
      saveFinanceData(currentSheetIndex);
    }

    function saveFinanceData(sheetId) {
      if (sheetId && ((Array.isArray(rows) && rows.length > 0) || (Array.isArray(cells) && cells.length > 0))) {
        const sheetPayload = {
          sheet: sheetId,
          rows,
          cells,
        };
        financeCrud(sheetPayload.sheet, sheetPayload, "put", (sheetResponse) => {
          if (sheetResponse?.status === true) {
            ReactNotifications(sheetResponse?.message, sucessState200);
            if (sheetId) {
              handleEditSheet({ title: currentSheet.name, id: sheetId }, sheetId, currentSheetType);
            }
            setHasUnsavedChanges(false);
            setIsBtnDisable(true);
            setIsSaving(false);
          } else {
            showApiErrors(sheetResponse)
            setIsSaving(false);
          }
        });
      }
      else {
        setIsSaving(false);
      }
      setHasUnsavedChanges(false);
    }
  };


  const handleEditSheet = (sheet, index, type) => {
    setLoading(true);
    setCurrentSheetIndex(index);
    setSelectedSheetInfo(sheet);
    setCurrentSheetType(type);
    setIsBtnDisable(false);

    financeCrud(index, {}, "get", (sheetResponse) => {
      if (sheetResponse?.status === true) {
        sheetResponse?.restored_from_version_date !== null && setSheetRestoredDate(sheetResponse?.restored_from_version_date);
        sheetResponse?.created_by_user !== null && setSheetCreatedById(sheetResponse?.created_by_user);
        setIsSheetLock(sheetResponse?.is_locked);
        sheetResponse?.data && setValidSheetData(sheetResponse?.data);

        const hiddenInfo = sheetResponse?.hidden;
        if (hiddenInfo && (hiddenInfo.rows || hiddenInfo.cols)) {
          setMaskedRange(hiddenInfo);
        } else {
          setMaskedRange(null);
        }
        const yearColumns =
          sheetResponse?.data?.[0]?.time_frame_data?.map((item) => item.year).filter(year => year) || [];
        const timeFrameColumns = yearColumns.length > 0 ? yearColumns : [defaultColumns[defaultColumns.length - 1]];
        const updatedColumns = [...defaultColumns.slice(0, -1), ...timeFrameColumns];

        const maxRowId = Array.isArray(sheetResponse?.data)
          ? Math.max(...sheetResponse.data.map((row) => row.row_id))
          : 0;

        const updatedRows = Array.from({ length: maxRowId }, (_, i) => {
          const rowData = sheetResponse?.data?.find((row) => parseInt(row.row_id) === i + 1) || null;
          if (rowData) {
            return [
              rowData.identifier_code || "",
              rowData.category_name || "",
              rowData.category_code || "",
              rowData.unit_name || "",
              ...(rowData.time_frame_data?.map((item) => item.value || "") || []),
            ];
          }
          return Array(updatedColumns.length).fill("");
        });

        setCurrentSheet({
          name: sheet?.title,
          data: [updatedColumns, ...updatedRows],
        });
        setAllComments(sheetResponse?.cells)
        setHasFetched(true);
      } else {
        setCurrentSheet({
          name: sheet?.title,
          data: [defaultColumns, defaultRow],
        });
        setAllComments([]);
      }
      setLoading(false);
      setIsModalOpen(true);
      setHasUnsavedChanges(false);
    });
  };

  const handleTableChange = (changes, source) => {
    if (!Array.isArray(changes) || source === 'add-new-revert') return;

    setIsBtnDisable(false);
    setHasUnsavedChanges(true);

    handleComment();

    if (source === "loadData") {
      return;
    }

    const updatedData = [...currentSheet.data];
    changes.forEach(([row, col, oldValue, newValue]) => {
      if (newValue === oldValue) return;

      if (col === 0 && newValue === "➕ New Company") {
        setIsCompanyModalOpen(true);
        hotTableRef.current.hotInstance.setDataAtCell(row, col, oldValue, 'add-new-revert');
        return;
      }

      if (col === 1 && newValue === "➕ New Category") {
        setIsCategoryModalOpen(true);
        hotTableRef.current.hotInstance.setDataAtCell(row, col, oldValue, 'add-new-revert');
        return;
      }

      if (col === 3 && newValue === "➕ New Unit") {
        setIsUnitModalOpen(true);
        hotTableRef.current.hotInstance.setDataAtCell(row, col, oldValue, 'add-new-revert');
        return;
      }

      if (col === 4 && newValue === "➕ New Year") {
        setIsYearModalOpen(true);
        hotTableRef.current.hotInstance.setDataAtCell(row, col, oldValue, 'add-new-revert');
        return;
      }

      if (!updatedData[row]) {
        updatedData[row] = [];
      }
      if (col === 1) {
        const selectedCategory = categories?.find((cat) => cat.name === newValue) || {};
        const defaultCode = selectedCategory.code || "";
        updatedData[row][2] = defaultCode;
      }

      if (typeof newValue === 'string' && newValue.startsWith('+DACR')) {
        const cleanedValue = newValue?.replace('+DACR(', '')?.slice(0, -1);
        const args = cleanedValue?.split(',')?.map(arg => arg?.trim());
        const [title, identifier_code, category_code, ...years] = args;

        const time_frame_data = years?.map(year => ({ year }));
        const result = {
          formula: [
            {
              title,
              identifier_code,
              category_code,
              time_frame_data,
            },
          ],
        };

        handleDacrFormula(result);

      }

      while (updatedData[row].length <= col) {
        updatedData[row].push("");
      }

      if (row === 0 && col >= 4 && (newValue === "" || newValue === null)) {
        updatedData[row][col] = "";
      } else {
        updatedData[row][col] = newValue;
      }
    });

    setCurrentSheet((prev) => ({
      ...prev,
      data: updatedData,
    }));
  };


  const handleDacrFormula = (payload) => {
    dacr(payload, (res) => {
      if (res?.status === true || res?.status === 200) {
        ReactNotifications(
          res?.message || res?.data?.message,
          utilConstants.sucessState200
        );
        let dataArray = res?.data?.data
        setCurrentSheet((prevState) => {
          const updatedSheet = { ...prevState };
          let headers = updatedSheet?.data[0];

          headers = headers?.filter((header) => header?.trim() !== "");

          dataArray?.forEach(({ identifier_code, category_name, category_code, unit, time_frame_data }) => {
            let matchingRowIndex = updatedSheet?.data?.findIndex(
              (row) => row?.[0] === identifier_code && row?.[1] === category_name
            );

            if (matchingRowIndex === -1) {
              const newRow = [identifier_code, category_name, category_code, unit, ...Array(headers?.length - 4)?.fill('')];
              updatedSheet?.data?.splice(1, 0, newRow);
              matchingRowIndex = 1;
            }

            time_frame_data?.forEach(({ year, value }) => {
              let timeIndex = headers?.indexOf("Time");
              let yearIndex = headers?.indexOf(year);

              if (timeIndex !== -1 && yearIndex === -1) {
                headers[timeIndex] = year;

                updatedSheet?.data?.forEach((row) => {
                  if (row?.[timeIndex] === "") {
                    row[timeIndex] = "";
                  }
                });

                yearIndex = timeIndex;
              }

              if (timeIndex === -1 && yearIndex === -1) {
                headers?.push(year);

                updatedSheet?.data?.forEach((row) => row?.push(''));
                yearIndex = headers?.length - 1;
              }

              updatedSheet.data[matchingRowIndex][yearIndex] = value;
            });

          });

          updatedSheet.data[0] = headers;

          return updatedSheet;
        });
      } else {
        ReactNotifications(
          res?.message || res?.data?.message,
          utilConstants.getErrorStatus
        );
      }
    });
  }

  const handleComment = () => {
    const hotInstance = hotTableRef.current?.hotInstance;
    const data = hotInstance.getData();
    setIsBtnDisable(false);


    if (hotInstance) {
      const commentsPlugin = hotInstance.getPlugin('comments');
      const allComments = [];

      for (let row = 0; row < data.length; row++) {
        for (let col = 0; col < data[row].length; col++) {
          const comment = commentsPlugin.getCommentAtCell(row, col);
          if (comment) {
            allComments.push({ row, col, comment: { value: comment, user_id: userId } });
          }
        }
      }

      setAllComments(allComments);
      return allComments;
    }
  }

  const fetchAllCategories = () => {
    categoryCrud({ page: false }, 'get', (response) => {
      if (response?.status === true) {
        const categoryNames = response?.data.map(item => item.category_name);
        const categoryCodes = response?.data.map(item => item.category_code);
        const categories = response.data.map(item => ({
          id: item.id,
          name: item.category_name,
          code: item.category_code,
        }));
        setCategories(categories);
        setCategoryNames(categoryNames);
        setCategoryCodes(categoryCodes);
      }
    });
  };

  const fetchAllCompanies = () => {
    companyCrud({ page: false }, 'get', (response) => {
      if (response?.status === true) {
        const identifierCodes = response?.data.map(item => item.identifier_code);
        const companies = response.data.map(item => ({
          id: item.id,
          name: item.identifier_code,
        }));
        setCompanies(companies);
        setCompanyIdentifiers(identifierCodes);
      }
    });
  }

  const fetchAllYears = () => {
    yearCrud({ page: false }, 'get', (response) => {
      if (response?.status === true) {
        const allYears = response.data.map(item => ({
          id: item.id,
          year: item.year,
        }));
        const years = response?.data.map(item => item.year);
        setAllYears(allYears);
        setYears(years);
      }
    });
  }

  const fetchAllUnits = () => {
    unitCrud({ page: false }, 'get', (response) => {
      if (response?.status === true) {
        const allUnits = response.data.map(item => ({
          id: item.id,
          unit: item.name,
        }));
        const units = response?.data.map(item => item.name);
        setAllUnits(allUnits);
        setUnits(units);
      }
    });
  }


  useEffect(() => {
    fetchAllCategories();
    fetchAllCompanies();
    fetchAllYears();
    fetchAllUnits();
  }, []);

  const handleVerticalScroll = () => {
    const totalRows = 1000;

    if (loadedRows < totalRows) {
      setLoadedRows((prev) => Math.min(prev + 10, totalRows));
    }
  };

  const handleHorizontalScroll = () => {
    const totalCols = 500;

    if (loadedCols < totalCols) {
      setLoadedCols((prev) => Math.min(prev + 5, totalCols));
    }
  };

  const handleDownload = () => {
    if (currentSheetIndex) {
      downloadToCsv({ sheet_ids: [currentSheetIndex] }, () => {
      });
    }
  }

  const handleClick = (sheet, id, tab) => {
    if (hasUnsavedChanges && isModalOpen) {
      const confirmed = window.confirm(
        "You have unsaved changes. Do you want to save before switching sheets?"
      );

      if (confirmed) {
        saveSheet();
        setTimeout(() => {
          setLoadingSheetId(id);
          handleEditSheet(sheet, id, tab);
        }, 500);
      } else {
        setLoadingSheetId(id);
        handleEditSheet(sheet, id, tab);
      }
    } else {
      setLoadingSheetId(id);
      handleEditSheet(sheet, id, tab);
    }
  };

  useImperativeHandle(ref, () => ({
    handleClick,
    handleCreateSheet,
  }));

  // const hashedRowRenderer = (td) => { td.innerHTML = '########'; };
  const hashedRowRenderer = (instance, td, row, col, prop, value, cellProperties) => { td.innerHTML = '########'; };

  return (
    <Container fluid style={{ padding: "10px" }}>
      <CompanyModal
        show={isCompanyModalOpen}
        onHide={() => setIsCompanyModalOpen(false)}
        initialData={null}
        onSaveSuccess={() => {
          fetchAllCompanies();
          setIsCompanyModalOpen(false);
        }}
      />
      <CategoryModal
        show={isCategoryModalOpen}
        onHide={() => setIsCategoryModalOpen(false)}
        initialData={null}
        onSaveSuccess={() => {
          fetchAllCategories();
          setIsCategoryModalOpen(false);
        }}
      />
      <UnitModal
        show={isUnitModalOpen}
        onHide={() => setIsUnitModalOpen(false)}
        initialData={null}
        onSaveSuccess={() => {
          fetchAllUnits();
          setIsUnitModalOpen(false);
        }}
      />
      <YearModal
        show={isYearModalOpen}
        onHide={() => setIsYearModalOpen(false)}
        initialData={null}
        onSaveSuccess={() => {
          fetchAllYears();
          setIsYearModalOpen(false);
        }}
      />
      {isModalOpen &&
        <div className="custom-modal-sheet">
          <div className="custom-modal-sheet-header flex flex-wrap items-center justify-between gap-4 sm:gap-6">
            <div className="flex gap-2 items-center flex-shrink-0">
              <Link to={`/personal/drive`} onClick={handleCloseModal}>
                <SiGooglesheets color="black" size={40} className="sm:w-10 sm:h-10 w-8 h-8" />
              </Link>
              <h1 className="modal-title-name">
                <input
                  type="text"
                  value={currentSheet?.name}
                  placeholder="Enter sheet name"
                  className="min-w-0 max-w-[150px] sm:max-w-[200px] md:max-w-none"
                  onChange={(e) => {
                    setCurrentSheet({ ...currentSheet, name: e.target.value });
                    setIsTitleChanged(true);
                    setHasUnsavedChanges(true);
                    setIsBtnDisable(false);
                  }}
                  disabled={sheetCreatedById !== user?.id && currentSheetIndex}
                />
              </h1>
            </div>

            <div className="flex flex-wrap items-center justify-end gap-3 sm:gap-4 relative">

              <AiUploadFeature
                sheet={selectedSheetInfo}
                fetchAllCategories={fetchAllCategories}
                fetchAllCompanies={fetchAllCompanies}
                fetchAllUnits={fetchAllUnits}
                fetchAllYears={fetchAllYears}
              />

              <VersionHistory
                id={loadingSheetId}
                handleEditSheet={handleEditSheet}
              />

              {currentSheetIndex && validSheetData.length > 0 && sheetCreatedById === user?.id && (
                <SheetLockFeature id={loadingSheetId} isSheetLock={isSheetLock} setIsSheetLock={setIsSheetLock} />
              )}

              {currentSheetIndex && validSheetData.length > 0 && sheetCreatedById === user?.id && !isSheetLock && user?.role !== "Personal User" && (
                <ShareSheetAccessModal id={loadingSheetId} />
              )}

              {currentSheetIndex && validSheetData.length > 0 && sheetCreatedById === user?.id && (
                <HideRowsAndCols sheetId={loadingSheetId} />
              )}

              {currentSheetIndex && validSheetData.length > 0 && (
                <CustomExportButton sheetId={loadingSheetId} />
              )}

              {currentSheetIndex && validSheetData.length > 0 && (
                <div
                  className="relative group flex items-center gap-1 sm:gap-2 px-2 sm:px-3  py-1 bg-white hover:bg-gray-50 border-2 border-gray-800 rounded-lg shadow-lg cursor-pointer transition-all duration-200 hover:shadow-xl"
                  onClick={handleDownload}
                  onMouseEnter={(e) => {
                    const tooltip = e.currentTarget.querySelector('.export-tooltip');
                    if (tooltip) tooltip.style.opacity = '1';
                  }}
                  onMouseLeave={(e) => {
                    const tooltip = e.currentTarget.querySelector('.export-tooltip');
                    if (tooltip) tooltip.style.opacity = '0';
                  }}
                >
                  <FaFileExport size={15} className="text-gray-700 sm:w-[20px] sm:h-[20px]" />
                  <span className="font-medium text-gray-800 text-sm sm:text-base xs:inline">Download</span>
                  <div
                    className="export-tooltip mt-2 z-[10000] absolute top-full left-1/2 mb-2 px-3 py-1.5 bg-gray-900 text-white text-xs rounded-md whitespace-nowrap pointer-events-none transition-opacity duration-200"
                    style={{
                      transform: 'translateX(-50%)',
                      opacity: 0,
                    }}
                  >
                    Download Sheet
                    <div
                      className="absolute bottom-full left-1/2 border-4 border-transparent border-b-gray-900"
                      style={{ transform: 'translateX(-50%)', marginBottom: '-8px' }}
                    ></div>
                  </div>
                </div>
              )}

              <div className="flex items-center">
                <button
                  disabled={isBtnDisable || isSaving}
                  className="flex items-center gap-2 px-3 sm:px-4 py-1 mr-[8px] bg-[#AEF468] border-2 border-gray-800 hover:bg-[#9DE357] text-black font-semibold rounded-lg shadow-lg transition-all duration-200 hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#AEF468] text-sm sm:text-base"
                  onClick={saveSheet}
                >
                  {isSaving ? (
                    <div className="flex items-center gap-2">
                      <div className="w-5 h-5 rounded-full border-2 border-t-black animate-spin"></div>
                      <span>Saving...</span>
                    </div>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>

              <button
                onClick={handleCloseModal}
                type="button"
                className=" top-0 bottom-3 right-0  sm:w-10 sm:h-10 flex items-center justify-center rounded-full bg-white hover:bg-red-50 text-gray-600 hover:text-red-600 border-2 border-gray-800 shadow-lg transition-all duration-200 hover:scale-110 hover:border-red-600 focus:outline-none focus:ring-2 focus:ring-red-500"
                aria-label="Close"
              >
                <svg className="!w-[25px] !h-[32px] sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
          <div className="custom-modal-sheet-inner" style={{ position: 'relative' }}>
            {isSheetLock && sheetCreatedById !== user?.id &&
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  zIndex: 10,
                  cursor: 'not-allowed'
                }}
                title="This sheet is locked by the owner"
              ></div>
            }
            <HotTable
              ref={hotTableRef}
              copyPaste={{
                rowsLimit: 1000,
                columnsLimit: 1000,
              }}
              fragmentSelection={false}
              manualColumnSelection={true}
              manualRowSelection={true}
              selectionMode="range"
              enterBeginsEditing={false}
              readOnly={isSheetLock && sheetCreatedById !== user?.id}
              data={currentSheet?.data?.slice(0, loadedRows)?.map((row) =>
                row?.slice(0, loadedCols)
              )}
              formulas={{
                engine: HyperFormula,
              }}
              colHeaders={true}
              rowHeaders={true}
              colWidths={new Array(26).fill(138)}
              fillHandle={true}
              contextMenu={{
                items: {
                  'row_above': {},
                  'row_below': {},
                  'col_left': {},
                  'col_right': {},
                  'separator1': '---------',
                  'undo': {},
                  'redo': {},
                  'make_read_only': {},
                  'separator2': '---------',
                  'alignment': {},
                  'cut': {},
                  'copy': {},
                  'paste': {
                    name: 'Paste (Ctrl+V)',
                    callback() {
                      this.listen();
                    }
                  },
                  'separator3': '---------',
                  'commentsAddEdit': {},
                  'commentsRemove': {},
                }
              }}
              comments={true}
              fixedRowsTop={1}
              stretchH="all"
              height={window.innerHeight - 140}
              autoWrapRow={true}
              autoWrapCol={true}
              outsideClickDeselects={false}
              autoRowSize={true}
              autoColumnSize={true}
              minRows={loadedRows}
              minCols={loadedCols}
              afterChange={handleTableChange}
              afterScrollVertically={handleVerticalScroll}
              afterScrollHorizontally={handleHorizontalScroll}
              manualColumnResize={true}
              manualRowResize={true}
              beforeOnCellMouseDown={(event, coords) => {
                if (coords.row === -1) {
                  event.stopImmediatePropagation();
                }
              }}
              cells={(row, col) => {
                if (maskedRange) {
                  const rowStart = maskedRange.rows?.start;
                  const rowEnd = maskedRange.rows?.end;
                  const colStart = maskedRange.cols?.start;
                  const colEnd = maskedRange.cols?.end;

                  const currentRow = row + 1;
                  const currentCol = col + 1;

                  const isRowMatch = (rowStart && rowEnd) ? (currentRow >= rowStart && currentRow <= rowEnd) : false;
                  const isColMatch = (colStart && colEnd) ? (currentCol >= colStart && currentCol <= colEnd) : false;

                  if ((isRowMatch && isColMatch) ||
                    (isRowMatch && (!colStart || !colEnd)) ||
                    (isColMatch && (!rowStart || !rowEnd))) {
                    return {
                      renderer: hashedRowRenderer,
                      readOnly: true,
                    };
                  }
                }

                if (row > 0) {
                  if (col === 0) {
                    return {
                      type: 'dropdown',
                      source: ['➕ New Company', ...companyIdentifiers],
                     // source: companyIdentifiers,
                      allowInvalid: false,
                      allowEmpty: true,
                      sortByRelevance: false,
                    };
                  }
                  if (col === 1) {
                    return {
                      type: 'dropdown',
                      source: ['➕ New Category', ...categoryNames],
                     // source: categoryNames,
                      allowInvalid: false,
                      allowEmpty: true,
                      sortByRelevance: false,
                    };
                  }
                  if (col === 2) {
                    return {
                      source: categoryCodes,
                      readOnly: true
                    };
                  }
                  if (col === 3) {
                    return {
                      type: 'dropdown',
                      source: ['➕ New Unit', ...units],
                      // source: units,
                      allowInvalid: false,
                      defaultValue: null,
                      allowEmpty: true,
                      sortByRelevance: false,
                    };
                  }

                } else {
                  if (col >= 4) {
                    return {
                      type: "dropdown",
                      source: ['➕ New Year', ...years],
                      //source: years,
                      className: "bold-first-row",
                      allowInvalid: false,
                      allowEmpty: true,
                      sortByRelevance: false,
                    };
                  }
                  if (row === 0) {
                    return {
                      className: "bold-first-row",
                      readOnly: 'true'
                    };
                  }
                }
                return {
                  type: 'text',
                };
              }}
              cell={allComments}
              licenseKey="non-commercial-and-evaluation"
            />
          </div>
        </div>
      }
    </Container>
  );
});

export default Sheet;